export default __webpack_public_path__ + "static/media/map-marker.dd6ba272.svg";